import request from '@/utils/request'

let Jz_menuApi = {

  /*兼职目录列表*/
  list(data) {
    return request._post('/shop/plus.jz_menu.Index/index', data);
},
/*添加兼职目录*/
add(data) {
    return request._post('/shop/plus.jz_menu.Index/add', data);
},
/*修改兼职目录*/
edit(data) {
    return request._post('/shop/plus.jz_menu.Index/edit', data);
},
/*删除兼职目录*/
del(data) {
    return request._post('/shop/plus.jz_menu.Index/del', data);
},
/*兼职目录详情*/
detail(data) {
  return request._post('/shop/plus.jz_menu.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.jz_menu.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.jz_menu.Setting/getSetting', data, errorback);
    },
}
export default Jz_menuApi;



// WEBPACK FOOTER //
// ./src/api/jz_menu.js